const config = Object.freeze({
  MODAL_MOTION_SICKNESS_EXPIRE_DELAY: 7,
});

export default config;
